// extracted by mini-css-extract-plugin
export default {"scope":"aUc5Z"};